import React from 'react';
import { useTestPipelineDrawerContext } from 'app/pipeline-details/StatusItem/TestPipelineDrawerContextProvider/TestPipelineDrawerContextProvider';
import PlaybookTransformationOutput from 'app/shared/components/testing-suite/PlaybookTransformationOutput';

export default function PipelineOutputTab() {
  const {
    state: {
      chainState: { pipelineOutput },
    },
  } = useTestPipelineDrawerContext();
  const { loading, error, outputEvent, errors } = pipelineOutput;

  if (error) {
    return null;
  }

  let props = {
    loading,
    trackingEventName: 'test_pipeline_pipeline_output_viewed',
  };

  if (!loading) {
    props = {
      ...props,
      outputEvent,
      outputErrors: errors,
    };
  }

  return <PlaybookTransformationOutput {...props} />;
}
